import { MAILBOX_STORAGE_KEYS } from "@/lib/localStorageKeys/mailbox";
import type { MailboxMessage } from "./stores/useMailboxStore";

type MailboxByAccount = Record<string, MailboxMessage[]>;

function readAll(): MailboxByAccount {
  if (typeof window === "undefined") return {};

  try {
    const raw = localStorage.getItem(MAILBOX_STORAGE_KEYS.BY_ACCOUNT);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as unknown;
    if (!parsed || typeof parsed !== "object") return {};
    return parsed as MailboxByAccount;
  } catch {
    return {};
  }
}

function writeAll(data: MailboxByAccount): void {
  if (typeof window === "undefined") return;

  try {
    localStorage.setItem(MAILBOX_STORAGE_KEYS.BY_ACCOUNT, JSON.stringify(data));
  } catch (error) {
    console.error("[Mailbox] Failed to save to localStorage:", error);
  }
}

export function loadMailboxMessages(accountKey: string): MailboxMessage[] {
  const all = readAll();
  return all[accountKey] ?? [];
}

export function saveMailboxMessages(accountKey: string, messages: MailboxMessage[]): void {
  const all = readAll();
  all[accountKey] = messages;
  writeAll(all);
}

export function clearMailboxMessages(accountKey: string): boolean {
  if (typeof window === "undefined" || !accountKey) return false;
  try {
    const all = readAll();
    if (!(accountKey in all)) return true;
    delete all[accountKey];
    writeAll(all);
    return true;
  } catch {
    return false;
  }
}

export function clearAllMailboxMessages(): boolean {
  if (typeof window === "undefined") return false;
  try {
    localStorage.removeItem(MAILBOX_STORAGE_KEYS.BY_ACCOUNT);
    return true;
  } catch {
    return false;
  }
}
